import { render, staticRenderFns } from "./PlayPlaceholder.vue?vue&type=template&id=17be23a2&"
import script from "./PlayPlaceholder.ts?vue&type=script&lang=ts&"
export * from "./PlayPlaceholder.ts?vue&type=script&lang=ts&"
import style0 from "./PlayPlaceholder.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports